export enum InvoiceStatus {
    OTHERS = "-1",
    UNKNOWN = "0",
    PAID = "1",
    COMPENSATED = "2",
    PARTIALLY_PAID = "3",
    NOT_PAID = "4",
    SEND_BACK_TO_COMPANY = "5",
    SEND_BANK = "6",
    REFUNDED = "7",
    PAID_BY_PAYMENT_PLAN = "8",
}

export enum InvoiceCategory {
    ALL = "",
    PAID = "paid",
    NOT_PAID = "unpaid",
    OTHERS = "other",
}

export const categoryToStatus = (index: string): InvoiceStatus => {
    switch (index) {
        case InvoiceCategory.NOT_PAID:
            return InvoiceStatus.NOT_PAID;
        case InvoiceCategory.PAID:
            return InvoiceStatus.PAID;
        case InvoiceCategory.OTHERS:
            return InvoiceStatus.OTHERS;
    }
};

export type InvoiceSortProperty = Paths.ApiInvoice.Get.Parameters.SortProperty;

export interface InvoiceDetails extends MyBrokerApi.InvoiceDetails {}

export interface SearchableInvoice extends MyBrokerApi.Invoice {
    amountString?: string;
    dateString?: string;
}
